function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _styled from 'styled-components';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { getMark, isMarkActive, setMarks } from '@udecode/plate-common';
import { useStoreEditorState, useEventEditorId, useStoreEditorRef, useStoreEditorSelection, getPlatePluginType } from '@udecode/plate-core';
import { ToolbarDropdown, ToolbarButton } from '@udecode/plate-toolbar';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
var ColorPicker = function ColorPicker(_ref) {
  var color = _ref.color,
    updateColor = _ref.updateColor;
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement("input", {
    type: "color",
    onChange: function onChange(ev) {
      return updateColor(ev, ev.target.value);
    },
    value: color || '#000000'
  }));
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "ColorPicker___StyledDiv",
  componentId: "sc-swnf2m-0"
})({
  "display": "flex"
});
var ToolbarColorPicker = function ToolbarColorPicker(_ref2) {
  var pluginKey = _ref2.pluginKey,
    icon = _ref2.icon;
  var editor = useStoreEditorState(useEventEditorId('focus'));
  var editorRef = useStoreEditorRef(useEventEditorId('focus'));
  var selection = useStoreEditorSelection(useEventEditorId('focus'));
  var type = getPlatePluginType(editor, pluginKey);
  var color = editorRef && getMark(editorRef, type);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedColor = _useState2[0],
    setSelectedColor = _useState2[1];
  var latestSelection = useRef();
  var updateColor = useCallback(function (ev, colorParam) {
    setSelectedColor(colorParam);
  }, []);
  useEffect(function () {
    if (selection) {
      latestSelection.current = selection;
      setSelectedColor(color);
    }
  }, [color, selection]);
  return /*#__PURE__*/React.createElement(ToolbarDropdown, {
    control: /*#__PURE__*/React.createElement(ToolbarButton, {
      active: !!(editor !== null && editor !== void 0 && editor.selection) && isMarkActive(editor, type),
      icon: icon
    }),
    onClose: function onClose(e) {
      if (editorRef && editor && latestSelection.current) {
        e.preventDefault();
        Transforms.select(editorRef, latestSelection.current);
        ReactEditor.focus(editorRef);
        if (selectedColor) {
          setMarks(editor, _defineProperty({}, type, selectedColor));
        }
      }
    }
  }, /*#__PURE__*/React.createElement(ColorPicker, {
    color: selectedColor || color,
    updateColor: updateColor
  }));
};
export { ColorPicker, ToolbarColorPicker };